import React, { useState } from 'react'
import UserContainerComponent from '../../../components/usersComponents/UserContainerComponent';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';

function AprobacionNueva() {
    const [date1, setDate1] = useState(new Date());
    const [date2, setDate2] = useState(new Date());
    const datos = [
        {   
            'rnc' : '131025987',
            'document' : 'E310000000001',
            'date' : '29/09/2024',
            'status' : 'Aprobado',
            'amount' : 1200.00,
            'options' : '',
        }
    ];
    const statusBodyTemplate = (product:any) => {
        return <Tag value={'Sin Aprobar'} severity={'warning'}></Tag>;
    };
    const formatCurrency = (value:any) => {
        return value.amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };
    return (
        <UserContainerComponent>
            <div className='px-4 lg:px-8'>
                <p className='font-bold mt-2 lg:mt-8 text-lg underline'>Realizar Aprobaci&oacute;n Comercial</p>
                <div className='grid grid-cols-2 lg:flex lg:flex-row gap-2 items-center'>
                    <label htmlFor="buttondisplay" className="font-bold text-base hidden lg:block">
                        Desde
                    </label>
                    <Calendar value={date1} onChange={(e:any) => setDate1(e.value)} 
                        dateFormat='dd/mm/yy' showIcon className='lg:max-w-[170px]'  />
                    <label htmlFor="buttondisplay" className="font-bold text-base hidden lg:block">
                        Hasta
                    </label>
                    <Calendar value={date2} onChange={(e:any) => setDate2(e.value)} 
                        dateFormat='dd/mm/yy' showIcon className='lg:max-w-[170px]' />
                    <Button size='small' onClick={()=> {window.scrollTo({top: 0, left: 0, behavior: 'smooth'});}} className='web-boton font-bold col-span-2 text-center justify-center'>
                            <i className="material-icons-outlined md-18">search</i>&nbsp;<span  >Buscar Datos</span>
                    </Button>
                </div>
                <div className="card mt-4">
                    <DataTable value={datos} tableStyle={{ minWidth: '50rem' }}
                        emptyMessage = {'No existen registros.'}>
                        <Column field="rnc" header="RNC"></Column>
                        <Column field="document" header="Documento"></Column>
                        <Column field="date" header="Fecha"></Column>
                        <Column body={statusBodyTemplate} header="Estado"></Column>
                        <Column body={formatCurrency} header="Monto"></Column>
                        <Column field="options" header="Opciones"></Column>
                    </DataTable>
                </div>
            </div>
        </UserContainerComponent>
    )
}

export default AprobacionNueva;